module.exports = __webpack_public_path__ + "res/34-img_game_text_bg.95d8353a8ee263c8432a22b5a86e9e75.png";